export default {
    Categories:[],
    product:{},
    order:{},
    paymentMethods:[]

}